import { Building2 } from "lucide-react";
import { ManualeLayout, Scheda, P, Bullets, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#4f46e5";
const SEZIONI = [
  { id: "intro", titolo: "Cos'è Gestione Agenzia" },
  { id: "moduli", titolo: "I moduli inclusi" },
  { id: "accesso", titolo: "Come si accede" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeGestioneAgenzia() {
  return (
    <ManualeLayout titolo="Gestione Agenzia" sottotitolo="Il contenitore delle attività amministrative interne" icona={Building2} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="Cos'è Gestione Agenzia" accent={A}>
        <P>È l'area che raccoglie i moduli per la <b>gestione interna</b> dell'agenzia (personale, adempimenti e organizzazione), separati dalle app operative rivolte ai clienti.</P>
      </Scheda>

      <Scheda id="moduli" n="2" titolo="I moduli inclusi" accent={A}>
        <Bullets items={[
          "Gestione del Personale — portale HR: fascicoli dipendenti, richieste assenze, note spese, cruscotto.",
          "Compliance Agenzia — formazione IVASS e scadenzario adempimenti.",
          "Chi fa cosa — responsabilità e checklist ricorrenti.",
        ]} />
        <P>Ogni modulo ha il proprio <b>Manuale operatore</b> dedicato, apribile dal pulsante “Manuale operatore” all'interno del modulo.</P>
      </Scheda>

      <Scheda id="accesso" n="3" titolo="Come si accede" accent={A}>
        <P>Dalla <b>Dashboard</b> apri la scheda <b>Gestione Agenzia</b>: vedrai le card dei moduli disponibili in base ai tuoi permessi. Clicca una card per entrare nel modulo.</P>
      </Scheda>

      <Scheda id="faq" n="4" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Perché non vedo tutti i moduli?", a: "Vengono mostrati solo i moduli per cui hai il permesso. Un Admin può abilitarti dalla gestione utenti." },
          { q: "I dipendenti entrano da qui?", a: "Sì: aprono 'Gestione del Personale' e vedono automaticamente solo la propria area riservata." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
